import axios from 'axios';

/**
 * ejemplo de uso
 * Se importa la clase GlobalServices
 GlobalServices._consultaRazonesSociales(urlService, data).then( respuesta => {
     //retorna la respuesta que se mando en "resolve"
 }).catch( error => {
     // retorna la respuesta que se mande en "reject"
 });
 */

/**
 * @param {url del servicio} urlService
 * @param {parametros del servcio} data
 *
 * data:
   {
	"discountCode":"",
	"iata":"",
	"agreement":"",
	"discount":"",
	"showINT":false
   }
 */
export function _consultaRazonesSociales( data, token, language){
    return new Promise ((resolve, reject) => {
        var jsonResponse = {
            status: 0,
            message: '',
            data: null
        }
        const urlService = process.env.VUE_APP_HOSTCORPORATEAPI + process.env.VUE_APP_CORPORATEAPI + process.env.VUE_APP_USER + process.env.VUE_APP_SR;
        axios({
            headers: {
              "Content-Type": "application/json",
              'Authorization': 'Bearer ' + token,
              "Accept-Language": language
            },
            method: "post",
            url: urlService,
            data: JSON.stringify(data)
          })
            .then(res => {
                jsonResponse.status = res.status;
                jsonResponse.message = res.data.message;
                jsonResponse.data = res.data.response;
                resolve(jsonResponse);
            })
            .catch(error => {
              if (error.response === undefined) {
                jsonResponse.message = error + "";
                jsonResponse.status = 0;
              } else {
                jsonResponse.message = error.response.statusText;
                jsonResponse.status = error.response.status;
                jsonResponse.errorCode = error.response.data.errorCode;
              }
              reject(jsonResponse);
            });
    });
}


/**
 *
 * @param {*} data
 * @param {*} token
 * @param {*} language
 */
/**
 * data
 {
	"hotelCode":"EXC",
	"arrivalDate":"25/09/2019",
	"departureDate":"27/09/2019",
	"contractCode":"BAI20",
	"currencyCode":"MXN",
	"dailyRate":1511.30,
	"totalRate":3022.60
 }
 */
export function _consultaPoliticasTarifas(token, language, data){
    return new Promise ((resolve, reject) => {
        var jsonResponse = {
            status: 0,
            message: '',
            data: null
        }
        const urlService = process.env.VUE_APP_HOSTCORPORATEAPI + process.env.VUE_APP_CORPORATEAPI + process.env.VUE_APP_RP;
        axios({
            headers: {
              "Content-Type": "application/json",
              'Authorization': 'Bearer ' + token,
              "Accept-Language": language
            },
            method: "post",
            url: urlService,
            data: JSON.stringify(data)
          })
            .then(res => {
                jsonResponse.status = res.status;
                jsonResponse.message = res.data.message;
                jsonResponse.data = res.data.response;
                resolve(jsonResponse);
            })
            .catch(error => {
              if (error.response === undefined) {
                jsonResponse.message = error + "";
                jsonResponse.status = 0;
              } else {
                jsonResponse.message = error.response.statusText;
                jsonResponse.status = error.response.status;
                jsonResponse.errorCode = error.response.data.errorCode;
              }
              reject(jsonResponse);
            });
    });
}


/**
 * 
 * @param {*} data 
 * @param {*} token 
 * @param {*} language 
*/
/**
  * data
 {
	"userType": "ADMIN",
	"contractType": "0",
	"discountCode": ""
}
 */

export function _consultaAllPoliticasViaje(data, token, language){
  return new Promise ((resolve, reject) => {
      var jsonResponse = {
          status: 0,
          message: '',
          data: null
      }
      const urlService = process.env.VUE_APP_HOSTCORPORATEAPI + process.env.VUE_APP_CORPORATEAPI + process.env.VUE_APP_TRAVEL_POLICY_ALL;
      axios({
          headers: {
            "Content-Type": "application/json",
            'Authorization': 'Bearer ' + token,
            "Accept-Language": language
          },
          method: "post",
          url: urlService,
          data: JSON.stringify(data)
        })
          .then(res => {
              jsonResponse.status = res.status;
              jsonResponse.message = res.data.message;
              jsonResponse.data = res.data.response;
              resolve(jsonResponse);
          })
          .catch(error => {
            if (error.response === undefined) {
              jsonResponse.message = error + "";
              jsonResponse.status = 0;
            } else {
              jsonResponse.message = error.response.statusText;
              jsonResponse.status = error.response.status;
              jsonResponse.errorCode = error.response.data.errorCode;
            }
            reject(jsonResponse);
          });
  });
}

/**
 * 
 * @param {*} policiYd 
 * @param {*} token 
 * @param {*} language 
*/
/**
  * data
 {
	"userType": "ADMIN",
	"contractType": "0",
	"discountCode": ""
}
 */

export function _deletePoliticasViaje(policyId, token, language){
  return new Promise ((resolve, reject) => {
      var jsonResponse = {
          status: 0,
          message: '',
          policyId: ''
      }
      const urlService = process.env.VUE_APP_HOSTCORPORATEAPI + process.env.VUE_APP_CORPORATEAPI + process.env.VUE_APP_TRAVEL_POLICY_DELETE + policyId;
      axios({
          headers: {
            "Content-Type": "application/json",
            'Authorization': 'Bearer ' + token,
            "Accept-Language": language
          },
          method: "delete",
          url: urlService,
          policyId: policyId
        })
          .then(res => {
              jsonResponse.status = res.status;
              jsonResponse.message = res.data.message;
              jsonResponse.data = res.data.response;
              resolve(jsonResponse);
          })
          .catch(error => {
            if (error.response === undefined) {
              jsonResponse.message = error + "";
              jsonResponse.status = 0;
            } else {
              jsonResponse.message = error.response.statusText;
              jsonResponse.status = error.response.status;
              jsonResponse.errorCode = error.response.data.errorCode;
            }
            reject(jsonResponse);
          });
  });
}



/**
 *
 * @param {*} data
 * @param {*} token
 * @param {*} language
 */
/**
 * data
 {
	"userType": "ADMIN",
	"contractType": "0",
	"discountCode": ""
}
 */
export function _consultaPoliticasViaje( data, token, language){
    return new Promise ((resolve, reject) => {
        var jsonResponse = {
            status: 0,
            message: '',
            data: null
        }
        const urlService = process.env.VUE_APP_HOSTCORPORATEAPI + process.env.VUE_APP_CORPORATEAPI + process.env.VUE_APP_TP;
        axios({
            headers: {
              "Content-Type": "application/json",
              'Authorization': 'Bearer ' + token,
              "Accept-Language": language
            },
            method: "post",
            url: urlService,
            data: JSON.stringify(data)
          })
            .then(res => {
              jsonResponse.status = res.status;
              jsonResponse.message = res.data.message;
              jsonResponse.data = res.data.response;
                resolve(jsonResponse);
            })
            .catch(error => {
              if (error.response === undefined) {
                jsonResponse.message = error + "";
                jsonResponse.status = 0;
              } else {
                jsonResponse.message = error.response.statusText;
                jsonResponse.status = error.response.status;
                jsonResponse.errorCode = error.response.data.errorCode;

              }
              reject(jsonResponse);
            });
    });
}

export function _consultaLogoYBanners(token){
  return new Promise ((resolve, reject) => {
    var jsonResponse = {
      status: 0,
      message: '',
      data: null
    }
    const urlService = process.env.VUE_APP_HOSTCORPORATEAPI + process.env.VUE_APP_CORPORATEAPI + process.env.VUE_APP_LOGOS;
    axios({
      headers: {
        'Authorization': 'Bearer ' + token
      },
      method: "GET",
      url: urlService,
    })
      .then(res => {
          jsonResponse.status = res.status;
          jsonResponse.message = res.data.message;
          jsonResponse.data = res.data.response;
          resolve(jsonResponse);
      })
      .catch(error => {
        if (error.response === undefined) {
          jsonResponse.message = error + "";
          jsonResponse.status = 0;
        } else {
          jsonResponse.message = error.response.statusText;
          jsonResponse.status = error.response.status;
          jsonResponse.errorCode = error.response.data.errorCode;
        }
        reject(jsonResponse);
      });
  });
}

export function _consultaHotelInfo(token, language){
  return new Promise ((resolve, reject) => {
    var jsonResponse = {
      status: 0,
      message: '',
      data: null
    }
    const urlService = process.env.VUE_APP_HOSTCORPORATEAPI + process.env.VUE_APP_CORPORATEAPI  + process.env.VUE_APP_HOTEL;

      axios.get( urlService, {
          withCredentials: true,
          credentials: 'include',
          headers: {
              'Authorization': 'Bearer ' + token,
              'Accept-language': language,
          }
      })
      .then(res => {
          jsonResponse.status = res.status;
          jsonResponse.message = res.statusText;
          jsonResponse.data = res.data;
          resolve(jsonResponse);
      })
      .catch(error => {
        if (error.response === undefined) {
          jsonResponse.message = error + "";
          jsonResponse.status = 0;
        } else {
          jsonResponse.message = error.response.statusText;
          jsonResponse.status = error.response.status;
          jsonResponse.errorCode = error.response.data.errorCode;
        }
        reject(jsonResponse);
      });
  });
}

import * as jsonESProd from '../assets/json/posadas_ES_PROD';
import * as jsonENProd from '../assets/json/posadas_EN_PROD';
import * as jsonhours from '../assets/json/posada_horarios';

export function _consultaHoteles(token, language){
  return new Promise ((resolve, reject) => {
    if (language == 'es') {
      resolve(jsonESProd.default);
    }
    if (language == 'en') {
      resolve(jsonENProd.default);
    }
  });
}

//Start KB41178
export function _consultaHotelesHours(){
  return new Promise ((resolve, reject) => {
      resolve(jsonhours.default);
  });
}
//End KB41178

export function _consultaLogos(token){
  return new Promise ((resolve, reject) => {
    var jsonResponse = {
      status: 0,
      message: '',
      data: null
    }
    const urlService = process.env.VUE_APP_HOSTCORPORATEAPI + process.env.VUE_APP_CORPORATEAPI + process.env.VUE_APP_LOGOS;
    axios({
      headers: {
        'Authorization': 'Bearer ' + token
      },
      method: "GET",
      url: urlService,
    })
      .then(res => {
          jsonResponse.status = res.status;
          jsonResponse.message = res.data.message;
          jsonResponse.data = res.data.response;
          resolve(jsonResponse);
      })
      .catch(error => {
        if (error.response === undefined) {
          jsonResponse.message = error + "";
          jsonResponse.status = 0;
        } else {
          jsonResponse.message = error.response.statusText;
          jsonResponse.status = error.response.status;
          jsonResponse.errorCode = error.response.data.errorCode;
        }
        reject(jsonResponse);
      });
  });
}

export function _consultaBanners(token, language){
  return new Promise ((resolve, reject) => {
    var jsonResponse = {
      status: 0,
      message: '',
      data: null
    }
    const urlService = process.env.VUE_APP_HOSTCORPORATEAPI + process.env.VUE_APP_CORPORATEAPI + process.env.VUE_APP_BANNERS;
    axios({
      headers: {
        'Accept-language': language,
        'Authorization': 'Bearer ' + token
      },
      method: "GET",
      url: urlService,
    })
      .then(res => {
          jsonResponse.status = res.status;
          jsonResponse.message = res.data.message;
          jsonResponse.data = res.data.response;
          resolve(jsonResponse);
      })
      .catch(error => {
        if (error.response === undefined) {
          jsonResponse.message = error + "";
          jsonResponse.status = 0;
        } else {
          jsonResponse.message = error.response.statusText;
          jsonResponse.status = error.response.status;
          jsonResponse.errorCode = error.response.data.errorCode;
        }
        reject(jsonResponse);
      });
  });
}

/**
 *
 * @param {*} data  data is hotelCode
 * @param {*} token
 * @param {*} language
 */
export function _consultaRequerimientos(data, token, language){
  return new Promise ((resolve, reject) => {
    var jsonResponse = {
      status: 0,
      message: '',
      data: null
    }
    const urlService = process.env.VUE_APP_HOSTCORPORATEAPI + process.env.VUE_APP_CORPORATEAPI + process.env.VUE_APP_REQUIREMENT + '/' + data;
    axios({
      headers: {
        "Accept-Language": language,
        'Authorization': 'Bearer ' + token
      },
      method: "GET",
      url: urlService,
    })
      .then(res => {
        jsonResponse.status = res.status;
        jsonResponse.message = res.data.message;
        jsonResponse.data = res.data.response;
        resolve(jsonResponse);
      })
      .catch(error => {
        if (error.response === undefined) {
          jsonResponse.message = error + "";
          jsonResponse.status = 0;
        } else {
          jsonResponse.message = error.response.statusText;
          jsonResponse.status = error.response.status;
          jsonResponse.errorCode = error.response.data.errorCode;
        }
        reject(jsonResponse);
      });
  });
}

/**
 *
 * @param {*} data
 * @param {*} token
 * @param {*} language
 *
 * data: {
	"hotelCode":"EXC",
	"currencyCode": "MXN",
	"arrivalDate": "10/10/2019",
	"departureDate": "14/10/2019",
	"contractCode": "BAI20",
	"numAdults": 2,
	"numChildren": 0,
	"numRooms": 1
}
 */
export function _consultaSuplementos(data, token, language){
  return new Promise ((resolve, reject) => {
    var jsonResponse = {
      status: 0,
      message: '',
      data: null
    }
    const urlService = process.env.VUE_APP_HOSTCORPORATEAPI + process.env.VUE_APP_CORPORATEAPI + process.env.VUE_APP_SUPPLEMENT;
    axios({
      headers: {
        "Content-Type": "application/json",
        "Accept-Language": language,
        'Authorization': 'Bearer ' + token
      },
      method: "POST",
      url: urlService,
      data: JSON.stringify(data)
    })
      .then(res => {
        jsonResponse.status = res.status;
        jsonResponse.message = res.data.message;
        jsonResponse.data = res.data.response;
        resolve(jsonResponse);
      })
      .catch(error => {
        if (error.response === undefined) {
          jsonResponse.message = error + "";
          jsonResponse.status = 0;
        } else {
          jsonResponse.message = error.response.statusText;
          jsonResponse.status = error.response.status;
          jsonResponse.errorCode = error.response.data.errorCode;
        }
        reject(jsonResponse);
      });
  });
}

/**
 *
 * @param {*} data
 * @param {*} token
 * @param {*} language
 *
 * data = {
	"hotelCode": "EXC",
	"arrivalDate": "27/09/2019",
	"departureDate":"29/09/2019",
	"currencyCode": "MXN",
	"contractCode": "DES20",
	"contractType": 0,
	"agreementCode": "",
	"iataCode": "",
	"motivacode": "",
	"userProperties": "101,102,103,104,106,107,108,109,117,119,121,122,124,128,133,136,137,138"
}
 */
export function _consultaMetodosPagos(data, token, language){
  return new Promise ((resolve, reject) => {
    var jsonResponse = {
      status: 0,
      message: '',
      data: null
    }
    const urlService = process.env.VUE_APP_HOSTCORPORATEAPI + process.env.VUE_APP_CORPORATEAPI + process.env.VUE_APP_P_VPM;
    axios({
      headers: {
        "Content-Type": "application/json",
        "Accept-Language": language,
        'Authorization': 'Bearer ' + token
      },
      method: "POST",
      url: urlService,
      data: JSON.stringify(data)
    })
      .then(res => {
        jsonResponse.status = res.status;
        jsonResponse.message = res.data.message;
        jsonResponse.data = res.data.response;
        resolve(jsonResponse);
      })
      .catch(error => {
        if (error.response === undefined) {
          jsonResponse.message = error + "";
          jsonResponse.status = 0;
        } else {
          jsonResponse.message = error.response.statusText;
          jsonResponse.status = error.response.status;
          jsonResponse.errorCode = error.response.data.errorCode;

        }
        reject(jsonResponse);
      });
  });
}

/**
 *
 * @param {*} token
 * @param {*} language
 */
export function _consultaLogosLifeRay(token, language){
  return new Promise ((resolve, reject) => {
    var jsonResponse = {
      status: 0,
      message: '',
      data: null
    }
    const urlService = process.env.VUE_APP_HOSTCORPORATEAPI + process.env.VUE_APP_CORPORATEAPI + process.env.VUE_APP_LOGOSLIFERAY;
    axios({
      headers: {
        'Authorization': 'Bearer ' + token,
        'Accept-Language': language
      },
      method: "POST",
      url: urlService,
    })
      .then(res => {
          jsonResponse.status = res.status;
          jsonResponse.message = res.data.message;
          jsonResponse.data = res.data.response;
          resolve(jsonResponse);
      })
      .catch(error => {
        if (error.response === undefined) {
          jsonResponse.message = error + "";
          jsonResponse.status = 0;
        } else {
          jsonResponse.message = error.response.statusText;
          jsonResponse.status = error.response.status;
          jsonResponse.errorCode = error.response.data.errorCode;
        }
        reject(jsonResponse);
      });
  });
}

/**
 *
 * @param {*} token
 * @param {*} language
 */
export function _consultaMotivosCancelacion(token, language){
  return new Promise ((resolve, reject) => {
    var jsonResponse = {
      status: 0,
      message: '',
      data: null
    }
    const urlService = process.env.VUE_APP_HOSTCORPORATEAPI + process.env.VUE_APP_CORPORATEAPI + process.env.VUE_APP_RC;
    axios({
      headers: {
        'Authorization': 'Bearer ' + token,
        'Accept-Language': language
      },
      method: "GET",
      url: urlService,
    })
      .then(res => {
          jsonResponse.status = res.status;
          jsonResponse.message = res.data.message;
          jsonResponse.data = res.data.response;
          resolve(jsonResponse);
      })
      .catch(error => {
        if (error.response === undefined) {
          jsonResponse.message = error + "";
          jsonResponse.status = 0;
        } else {
          jsonResponse.message = error.response.statusText;
          jsonResponse.status = error.response.status;
          jsonResponse.errorCode = error.response.data.errorCode;
        }
        reject(jsonResponse);
      });
  });
}

/**
 *
 * @param {*} token
 * @param {*} language
 * @param {*} data
 * data:
 * {
	  "profileId": "POSADAS",
	  "username": "posadas",
    "userType" : "SUPER_ADMIN",
    "reservationNumber" : "123456",
    "email" : "diegoj@gluo.mx",
    "cancelationMotive" : "CD",
    "cancelationReason" : "No puedo ir"
  }
 */
export function _cancelarAclaracionReservacion(token, language, data){
  return new Promise ((resolve, reject) => {
    var jsonResponse = {
      status: 0,
      message: '',
      data: null
    }
    const urlService = process.env.VUE_APP_HOSTCORPORATEAPI + process.env.VUE_APP_CORPORATEAPI + process.env.VUE_APP_CLACAN;
    axios({
      headers: {
        "Content-Type": "application/json",
        'Authorization': 'Bearer ' + token,
        'Accept-Language': language
      },
      method: "POST",
      url: urlService,
      data: JSON.stringify(data)
    })
      .then(res => {
          jsonResponse.status = res.status;
          jsonResponse.message = res.data.message;
          jsonResponse.data = res.data.response;
          resolve(jsonResponse);
      })
      .catch(error => {
        if (error.response === undefined) {
          jsonResponse.message = error + "";
          jsonResponse.status = 0;
        } else {
          jsonResponse.message = error.response.statusText;
          jsonResponse.status = error.response.status;
          jsonResponse.errorCode = error.response.data.errorCode;
        }
        reject(jsonResponse);
      });
  });
}

/**
 *
 * @param {*} token
 * @param {*} language
 * @param {*} data
 data:
 {
	"profileId": "POSADAS",
	"username": "posadas",
    "userType" : "SUPER_ADMIN",
    "reservationNumber" : "123456",
    "arrivalDateReal": "20/12/2019",
    "departureDateReal": "23/12/2019",
    "arrivalDateDesired": "10/01/2020",
    "departureDateDesired": "13/01/2020",
    "email" : "diegoj@gluo.mx",
    "commentsAdditional" : "La quiero modificar"
}
 */
export function _modificarAclaracionReservacion(token, language, data){
  return new Promise ((resolve, reject) => {
    var jsonResponse = {
      status: 0,
      message: '',
      data: null
    }
    const urlService = process.env.VUE_APP_HOSTCORPORATEAPI + process.env.VUE_APP_CORPORATEAPI + process.env.VUE_APP_ACLMOD;
    axios({
      headers: {
        "Content-Type": "application/json",
        'Authorization': 'Bearer ' + token,
        'Accept-Language': language
      },
      method: "POST",
      url: urlService,
      data: JSON.stringify(data)
    })
      .then(res => {
          jsonResponse.status = res.status;
          jsonResponse.message = res.data.message;
          jsonResponse.data = res.data.response;
          resolve(jsonResponse);
      })
      .catch(error => {
        if (error.response === undefined) {
          jsonResponse.message = error + "";
          jsonResponse.status = 0;
        } else {
          jsonResponse.message = error.response.statusText;
          jsonResponse.status = error.response.status;
          jsonResponse.errorCode = error.response.data.errorCode;
        }
        reject(jsonResponse);
      });
  });
}

/**
 *
 * @param {*} token
 * @param {*} language
 * @param {*} data
 data: {
	"profileId": "POSADAS",
	"username": "posadas",
  "reservationNumber" : "123456",
  "email" : "diegoj@gluo.mx",
  "commentsAdditional" : "Quiero aclarar la reserva"
}
 */
export function _aclaracionReservacion(token, language, data){
  return new Promise ((resolve, reject) => {
    var jsonResponse = {
      status: 0,
      message: '',
      data: null
    }
    const urlService = process.env.VUE_APP_HOSTCORPORATEAPI + process.env.VUE_APP_CORPORATEAPI + process.env.VUE_APP_ACLRESER;
    axios({
      headers: {
        "Content-Type": "application/json",
        'Authorization': 'Bearer ' + token,
        'Accept-Language': language
      },
      method: "POST",
      url: urlService,
      data: JSON.stringify(data)
    })
      .then(res => {
          jsonResponse.status = res.status;
          jsonResponse.message = res.data.message;
          jsonResponse.data = res.data.response;
          resolve(jsonResponse);
      })
      .catch(error => {
        if (error.response === undefined) {
          jsonResponse.message = error + "";
          jsonResponse.status = 0;
        } else {
          jsonResponse.message = error.response.statusText;
          jsonResponse.status = error.response.status;
          jsonResponse.errorCode = error.response.data.errorCode;
        }
        reject(jsonResponse);
      });
  });
}

/**
 *
 * @param {*} token
 * @param {*} language
 * @param {*} data
 data :
 {
	"reservationId":"736656558",
	"hotelName":"Live Aqua Cancun Resort",
	"checkIn":"27/12/2019",
	"checkOut":"31/12/2019",
	"guest":"Diego Jardon",
	"showRates":"true",
	"showPublicRates":"true",
	"emails":["diegoj@gluo.mx"]
}
 */
export function _enviarEmailProforma(token, language, data){
  return new Promise ((resolve, reject) => {
    var jsonResponse = {
      status: 0,
      message: '',
      data: null
    }
    const urlService = process.env.VUE_APP_HOSTCORPORATEAPI + process.env.VUE_APP_CORPORATEAPI + process.env.VUE_APP_SENDMAILPROF;
    axios({
      headers: {
        "Content-Type": "application/json",
        'Authorization': 'Bearer ' + token,
        'Accept-Language': language
      },
      method: "POST",
      url: urlService,
      data: JSON.stringify(data)
    })
      .then(res => {
          jsonResponse.status = res.status;
          jsonResponse.message = res.data.message;
          jsonResponse.data = res.data.response;
          resolve(jsonResponse);
      })
      .catch(error => {
        if (error.response === undefined) {
          jsonResponse.message = error + "";
          jsonResponse.status = 0;
        } else {
          jsonResponse.message = error.response.statusText;
          jsonResponse.status = error.response.status;
          jsonResponse.errorCode = error.response.data.errorCode;
        }
        reject(jsonResponse);
      });
  });
}

/**
 *
 * @param {*} token
 * @param {*} language
 * @param {*} data
 data:
  {
    “confirmationNumber”: “736687582",
    “profileType”: “SOB”,
    “emailList”: [“diegoj@gluo.mx”]
  }
 */
export function _enviarEmailReservacion(token, language, data){
  return new Promise ((resolve, reject) => {
    var jsonResponse = {
      status: 0,
      message: '',
      data: null
    }
    const urlService = process.env.VUE_APP_HOSTCORPORATEAPI + process.env.VUE_APP_CORPORATEAPI + process.env.VUE_APP_MAILFORWARDING;
    axios({
      headers: {
        "Content-Type": "application/json",
        'Authorization': 'Bearer ' + token,
        'Accept-Language': language
      },
      method: "POST",
      url: urlService,
      data: JSON.stringify(data)
    })
      .then(res => {
          jsonResponse.status = res.status;
          jsonResponse.message = res.data.message;
          jsonResponse.data = res.data.response;
          resolve(jsonResponse);
      })
      .catch(error => {
        if (error.response === undefined) {
          jsonResponse.message = error + "";
          jsonResponse.status = 0;
        } else {
          jsonResponse.message = error.response.statusText;
          jsonResponse.status = error.response.status;
          jsonResponse.errorCode = error.response.data.errorCode;
        }
        reject(jsonResponse);
      });
  });
}

/**
 *
 * @param {*} token
 * @param {*} language
 * @param {*} data
 *
 data:
 {
    "confirmationNumber": "736872032",
	    "profileType": "SOB",
    "hasEditCancelPermissions":true,
    "fullReservationData":true
}
 */
export function _hotelReservationByCode(token, language, data){
  return new Promise ((resolve, reject) => {
    var jsonResponse = {
      status: 0,
      message: '',
      data: null
    }
    const urlService = process.env.VUE_APP_HOSTCORPORATEAPI + process.env.VUE_APP_CORPORATEAPI + process.env.VUE_APP_CODE;
    axios({
      headers: {
        "Content-Type": "application/json",
        'Authorization': 'Bearer ' + token,
        'Accept-Language': language
      },
      method: "POST",
      url: urlService,
      data: JSON.stringify(data)
    })
      .then(res => {
          jsonResponse.status = res.status;
          jsonResponse.message = res.data.message;
          jsonResponse.data = res.data.response;
          resolve(jsonResponse);
      })
      .catch(error => {
        if (error.response === undefined) {
          jsonResponse.message = error + "";
          jsonResponse.status = 0;
        } else {
          jsonResponse.message = error.response.statusText;
          jsonResponse.status = error.response.status;
          jsonResponse.errorCode = error.response.data.errorCode;
        }
        reject(jsonResponse);
      });
  });
}


/**
 *
 * @param {*} token
 * @param {*} language
 * @param {*} data
 * data:
  {
	"hotelCode": "FAM",
	"arrivalDate": "01/02/2020",
	"departureDate": "03/02/2020",
	"currencyCode": "MXN",
	"totalAdults": 1,
	"totalChildren": 0,
	"totalInfants": 0,
	"totalRooms": 1,
	"agreementCode": "",
	"iataCode": "",
	"motivaCode": "",
	"discountCode": "",
	"promoCode": "",
	"profileType": "SOB",
	"showPublicRates": true,
	"showRates":true,
	"contractCode":"CCR271",
	"roomCodeList":["DDP"]
}
 */
export function _searchavailibility(token, language, data){
  return new Promise ((resolve, reject) => {
    var jsonResponse = {
      status: 0,
      message: '',
      data: null
    }
    const urlService = process.env.VUE_APP_HOSTCORPORATEAPI + process.env.VUE_APP_CORPORATEAPI + process.env.VUE_APP_HOTEL + '/' + process.env.VUE_APP_AVAILIBILITY;
    axios({
      headers: {
        "Content-Type": "application/json",
        'Authorization': 'Bearer ' + token,
        'Accept-Language': language
      },
      method: "POST",
      url: urlService,
      data: JSON.stringify(data)
    })
      .then(res => {
          jsonResponse.status = res.status;
          jsonResponse.message = res.data.message;
          jsonResponse.data = res.data.response;
          resolve(jsonResponse);
      })
      .catch(error => {
        if (error.response === undefined) {
          jsonResponse.message = error + "";
          jsonResponse.status = 0;
        } else {
          jsonResponse.message = error.response.statusText;
          jsonResponse.status = error.response.status;
          jsonResponse.errorCode = error.response.data.errorCode;
        }
        reject(jsonResponse);
      });
  });
}

/**
 * 
 * @param {*} token 
 * @param {*} language 
 * @param {*} profileId 
 * 
 * profileId: POSADAS
 */
export function _consultaProfileById(token, language, profileId){
  return new Promise ((resolve, reject) => {
    var jsonResponse = {
      status: 0,
      message: '',
      data: null
    }
    const urlService = process.env.VUE_APP_HOSTCORPORATEAPI + process.env.VUE_APP_CORPORATEAPI + process.env.VUE_APP_PROFILE_BY_ID + '?profileId=' + profileId;
    axios({
      headers: {
        "Content-Type": "application/json",
        'Authorization': 'Bearer ' + token,
        'Accept-Language': language
      },
      method: "GET",
      url: urlService,
    })
      .then(res => {
          jsonResponse.status = res.status;
          jsonResponse.message = res.data.message;
          jsonResponse.data = res.data.response;
          resolve(jsonResponse);
      })
      .catch(error => {
        if (error.response === undefined) {
          jsonResponse.message = error + "";
          jsonResponse.status = 0;
        } else {
          jsonResponse.message = error.response.statusText;
          jsonResponse.status = error.response.status;
          jsonResponse.errorCode = error.response.data.errorCode;
        }
        reject(jsonResponse);
      });
  });
}


/**
 * 
 * @param {*} token 
 * @param {*} language 
 * @param {*} policyId id de la politica
 */
export function _consultaPolicyDetailById(token, language, policyId){
  return new Promise ((resolve, reject) => {
    var jsonResponse = {
      status: 0,
      message: '',
      data: null
    }
    const urlService = process.env.VUE_APP_HOSTCORPORATEAPI + process.env.VUE_APP_CORPORATEAPI + process.env.VUE_APP_PODET + policyId;
    axios({
      headers: {
        "Content-Type": "application/json",
        'Authorization': 'Bearer ' + token,
        'Accept-Language': language
      },
      method: "GET",
      url: urlService,
    })
      .then(res => {
          jsonResponse.status = res.status;
          jsonResponse.message = res.data.message;
          jsonResponse.data = res.data.response;
          resolve(jsonResponse);
      })
      .catch(error => {
        if (error.response === undefined) {
          jsonResponse.message = error + "";
          jsonResponse.status = 0;
        } else {
          jsonResponse.message = error.response.statusText;
          jsonResponse.status = error.response.status;
          jsonResponse.errorCode = error.response.data.errorCode;
        }
        reject(jsonResponse);
      });
  });
}

/**
 * 
 * @param {*} token 
 * @param {*} language 
 * @param {*} data
 * data: {
  "userId": "posadas",
  "userType": "SUPER_ADMIN",
  "profileUserId": "POSADAS",
  "idPolicy": "",
  "nameTravelPolicy": "politica 6 abril 2020",
  "usersModels": [
    {
      "travelPolicyId": 0,
      "userId": "posadas.agente",
      "priority": 0
    },
    {
      "travelPolicyId": 0,
      "userId": "corpo.agentenai",
      "priority": 0
    }
  ],
  "additionals": [
    {
      "itemId": 12,
      "value": "300",
      "typeAddItem": "predefinedItems"
    },
	{
      "itemId": 14,
      "value": "5",
      "typeAddItem": "predefinedItems"
    },
    {
      "itemId": 1,
      "value": "true",
      "typeAddItem": "predefinedItems"
    },
    {
      "itemId": 15,
      "value": "Este es un comentario",
      "typeAddItem": "predefinedItems"
    }
  ]

}
 */
export function _newTravelPolicy(token, language, data){
  return new Promise ((resolve, reject) => {
    var jsonResponse = {
      status: 0,
      message: '',
      data: null
    }
    const urlService = process.env.VUE_APP_HOSTCORPORATEAPI + process.env.VUE_APP_CORPORATEAPI + process.env.VUE_APP_TP + process.env.VUE_APP_TP_CREATE;
    axios({
      headers: {
        "Content-Type": "application/json",
        'Authorization': 'Bearer ' + token,
        'Accept-Language': language
      },
      method: "POST",
      url: urlService,
      data: JSON.stringify(data)
    })
      .then(res => {
          jsonResponse.status = res.status;
          jsonResponse.message = res.data.message;
          jsonResponse.data = res.data.response;
          resolve(jsonResponse);
      })
      .catch(error => {
        if (error.response === undefined) {
          jsonResponse.message = error + "";
          jsonResponse.status = 0;
        } else {
          jsonResponse.message = error.response.statusText;
          jsonResponse.status = error.response.status;
          jsonResponse.errorCode = error.response.data.errorCode;
        }
        reject(jsonResponse);
      });
  });
}

/**
 * 
 * @param {*} token 
 * @param {*} language 
 */
export function _consultarPredefinedItems(token, language){
  return new Promise ((resolve, reject) => {
    var jsonResponse = {
      status: 0,
      message: '',
      data: null
    }
    const urlService = process.env.VUE_APP_HOSTCORPORATEAPI + process.env.VUE_APP_CORPORATEAPI + process.env.VUE_APP_TP + process.env.VUE_APP_TP_PREDEFINED;
    axios({
      headers: {
        "Content-Type": "application/json",
        'Authorization': 'Bearer ' + token,
        'Accept-Language': language
      },
      method: "GET",
      url: urlService,
    })
      .then(res => {
          jsonResponse.status = res.status;
          jsonResponse.message = res.data.message;
          jsonResponse.data = res.data.response;
          resolve(jsonResponse);
      })
      .catch(error => {
        if (error.response === undefined) {
          jsonResponse.message = error + "";
          jsonResponse.status = 0;
        } else {
          jsonResponse.message = error.response.statusText;
          jsonResponse.status = error.response.status;
          jsonResponse.errorCode = error.response.data.errorCode;
        }
        reject(jsonResponse);
      });
  });
}

/**
 * 
 * @param {*} token 
 * @param {*} language 
 */
export function _consultarUsuariosPorLogin(token, language){
  return new Promise ((resolve, reject) => {
    var jsonResponse = {
      status: 0,
      message: '',
      data: null
    }
    const urlService = process.env.VUE_APP_HOSTCORPORATEAPI + process.env.VUE_APP_CORPORATEAPI + process.env.VUE_APP_USER + process.env.VUE_APP_LUR;
    axios({
      headers: {
        "Content-Type": "application/json",
        'Authorization': 'Bearer ' + token,
        'Accept-Language': language
      },
      method: "POST",
      url: urlService,
    })
      .then(res => {
          jsonResponse.status = res.status;
          jsonResponse.message = res.data.message;
          jsonResponse.data = res.data.response;
          resolve(jsonResponse);
      })
      .catch(error => {
        if (error.response === undefined) {
          jsonResponse.message = error + "";
          jsonResponse.status = 0;
        } else {
          jsonResponse.message = error.response.statusText;
          jsonResponse.status = error.response.status;
          jsonResponse.errorCode = error.response.data.errorCode;
        }
        reject(jsonResponse);
      });
  });
}

/**
 * 
 * @param {*} token 
 * @param {*} language 
 * @param {*} data 
 * data:
 * {
  "userId": "posadas",
  "userType": "SUPER_ADMIN",
  "profileUserId": "POSADAS",
  "travelPolicyId": 3617,
  "nameTravelPolicy": "politica 8.1 abril 2020",
  "usersModels": [
    {
      "userId": "posadasfar"
    },
    {
      "userId": "user.problems"
    },
    {
      "userId": "edwin"
    }
  ],
  "additionals": [
    {
      "itemId": 12,
      "value": "250",
      "typeAddItem": "predefinedItems"
    },
	{
      "itemId": 14,
      "value": "10",
      "typeAddItem": "predefinedItems"
    },
    {
      "itemId": 2,
      "value": "true",
      "typeAddItem": "predefinedItems"
    },
    {
      "itemId": 15,
      "value": "Este es un comentario 8.1",
      "typeAddItem": "predefinedItems"
    }
  ]

}
 */
export function _updateTravelPolicy(token, language, data){
  return new Promise ((resolve, reject) => {
    var jsonResponse = {
      status: 0,
      message: '',
      data: null
    }
    const urlService = process.env.VUE_APP_HOSTCORPORATEAPI + process.env.VUE_APP_CORPORATEAPI + process.env.VUE_APP_TP + process.env.VUE_APP_TP_UPDATE;
    axios({
      headers: {
        "Content-Type": "application/json",
        'Authorization': 'Bearer ' + token,
        'Accept-Language': language
      },
      method: "POST",
      url: urlService,
      data: JSON.stringify(data)
    })
      .then(res => {
          jsonResponse.status = res.status;
          jsonResponse.message = res.data.message;
          jsonResponse.data = res.data.response;
          resolve(jsonResponse);
      })
      .catch(error => {
        if (error.response === undefined) {
          jsonResponse.message = error + "";
          jsonResponse.status = 0;
        } else {
          jsonResponse.message = error.response.statusText;
          jsonResponse.status = error.response.status;
          jsonResponse.errorCode = error.response.data.errorCode;
        }
        reject(jsonResponse);
      });
  });
}

/**
 * 
 * @param {*} token 
 * @param {*} language 
 * @param {*} data
 * data: 
 * {
      "newUser": "",
      "userId": "sincity5"
    } 
 */
export function _deleteUser(token, language, data){
  return new Promise ((resolve, reject) => {
    var jsonResponse = {
      status: 0,
      message: '',
      data: null
    }
    const urlService = process.env.VUE_APP_HOSTCORPORATEAPI + process.env.VUE_APP_CORPORATEAPI + process.env.VUE_APP_DELUSER;
    axios({
      headers: {
        "Content-Type": "application/json",
        'Authorization': 'Bearer ' + token,
        'Accept-Language': language
      },
      method: "DELETE",
      url: urlService,
      data: JSON.stringify(data)
    })
      .then(res => {
          jsonResponse.status = res.status;
          jsonResponse.message = res.data.message;
          jsonResponse.data = res.data.response;
          resolve(jsonResponse);
      })
      .catch(error => {
        if (error.response === undefined) {
          jsonResponse.message = error + "";
          jsonResponse.status = 0;
        } else {
          jsonResponse.message = error.response.statusText;
          jsonResponse.status = error.response.status;
          jsonResponse.errorCode = error.response.data.errorCode;
          jsonResponse.data = error.response.data;
        }
        reject(jsonResponse);
      });
  });
}

/**
 * 
 * @param {*} token 
 * @param {*} language 
 * @param {*} data 
 * data: {
    "userId": userId,
    "clientId":this.ls.get('clientIdAdd').data.toUpperCase()
    }
 */
export function _userDetailsResults(token, language, data){
  return new Promise ((resolve, reject) => {
    var jsonResponse = {
      status: 0,
      message: '',
      data: null
    }
    const urlService = process.env.VUE_APP_HOSTCORPORATEAPI + process.env.VUE_APP_CORPORATEAPI + process.env.VUE_APP_CONDU;
    axios({
      headers: {
        "Content-Type": "application/json",
        'Authorization': 'Bearer ' + token,
        'Accept-Language': language
      },
      method: "POST",
      url: urlService,
      data: JSON.stringify(data)
    })
      .then(res => {
          jsonResponse.status = res.status;
          jsonResponse.message = res.data.message;
          jsonResponse.data = res.data.response;
          resolve(jsonResponse);
      })
      .catch(error => {
        if (error.response === undefined) {
          jsonResponse.message = error + "";
          jsonResponse.status = 0;
        } else {
          jsonResponse.message = error.response.statusText;
          jsonResponse.status = error.response.status;
          jsonResponse.errorCode = error.response.data.errorCode;
          jsonResponse.data = error.response.data;
        }
        reject(jsonResponse);
      });

  });
}
/**
 * 
 * @param {*} token 
 * @param {*} language 
 * @param {*} data 
 * data: {
    "groupCode": groupCode,
    "hotelCode": hotelCode
    
    }
 */
export function _searchgroupinfo(token, language, data){
      return new Promise ((resolve, reject) => {
        console.log(data.groupCode, data.hotelCode);
        var jsonResponse = {
          status: 0,
          message: '',
          data: null
        }
        const urlService = process.env.VUE_APP_HOSTCORPORATEAPI + process.env.VUE_APP_CORPORATEAPI + process.env.VUE_APP_SEARCHGROUPINFO;
        
        axios({
          headers: {
            "Content-Type": "application/json",
            'Authorization': 'Bearer ' + token,
            'Accept-Language': language
          },
          method: "POST",
          url: urlService,
          data: JSON.stringify(data)
          
        })
          .then(res => {
              console.log(res.data.response);
              jsonResponse.status = res.status;
              jsonResponse.message = res.data.message;
              jsonResponse.data = res.data.response;
              resolve(jsonResponse);
          })
          .catch(error => {
            if (error.response === undefined) {
              jsonResponse.message = error + "";
              jsonResponse.status = 0;
            } else {
              jsonResponse.message = error.response.statusText;
              jsonResponse.status = error.response.status;
              jsonResponse.errorCode = error.response.data.errorCode;
              jsonResponse.data = error.response.data;
            }
            reject(jsonResponse);
          });
    
      });
    }